<template>
      <main class="main">
        <div class="worker">
          <div class="worker-header">
            <div class="worker-header-navigation">
              <button class="">Основное</button><hr>
              <button class="">Реквизиты</button><hr>
              <button class="">Филиалы</button><hr>
              <button class="active">Магазины</button><hr>
              <button class="">Поставщики</button><hr>
              <button class="">Мой тариф</button>
            </div>
            <div class="worker-search">
              <input autocomplete="off" name="search" placeholder="Поиск поставщика">
              <img class="hover_btn" src="@/assets/img/worker/search.svg" alt="">
            </div>
            <button class="worker-add">Добавить поставщика</button>
          </div>
          <app-checkbox>Не показывать неактивные договоры</app-checkbox>
          <div class="worker-main">
            <table class="worker-table">
              <tr>
                <th>ID<img src="@/assets/img/main/open.svg"></th>
                <th>Наименование</th>
                <th>ИНН</th>
                <th>Договор</th>
                <th>Срок действия</th>
                <th>Статус</th>
              </tr>
              <tr>
                <td>1</td>
                <td>
                  <img src="" alt="" class="worker-avatar">
                  <span>ООО "Охота и рыбалка"</span>
                </td>
                <td>344407702933</td>
                <td>343534632334</td>
                <td>13 сентября 2020</td>
                <td class="true">Действует</td>

              </tr>
              <tr>
                <td>2</td>
                <td>
                  <img src="" alt="" class="worker-avatar">
                  <span>ООО "Охота и рыбалка"</span>
                </td>
                <td>344407702933</td>
                <td>343534632334</td>
                <td>13 сентября 2020</td>
                <td>Недействительный</td>

              </tr>
            </table>
          </div>
        </div>
      </main>
</template>

<script>
    import AppCheckbox from "@/components/app-checkbox";
    export default {
        name: "edit",
      components: { AppCheckbox }
    }
</script>

<style scoped lang="scss">
  .worker {
    &-main{
      border-radius: 5px;
      box-shadow: 0px 0px 3px #E5E5EA;
      outline: hidden;
    }
    &-table {
      border-collapse: collapse;
      width: 100%;
      background: #fff;
      border: 1px #EEF0F3 solid;
      border-radius: 5px;
      tr {
        &:nth-child(even) {
          background: #F9F9FB;
        }
      }
      th, td {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        padding: 7px 14px;
        height: 40px;
        text-align: left;
        img{
          margin-right: -11px;
          margin-left: 2px;
        }
        &.true{
          font-family: Roboto;
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 16px;
          color: #2CB181;        }
        &:not(:last-child) {
          border-right: 1px #EEF0F3 solid;
        }
      }
      th {
        color: #2D3137;
      }
      tr {
        color: #7A818F;
      }
    }
    &-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      &-navigation{
        width: 60%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 8px 0 0;
        background-color: #FFFFFF;
        border-radius: 0px;
        button{
          height: 40px;
          border: none;
          outline: none;
          width: 100%;
          background-color: #FFFFFF;
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 16px;
          color: #7A818F;
          cursor: pointer;
          padding: 0 15px;
          margin: 2px 0;
          border-radius: 0px;
        }
        .active{
          background: #EEF0F3;
          border-radius: 4px;
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 16px;
          color: #2D3137;
          margin: 0 -5px;
        }
        hr{
          height: 20px;
          border: 1px solid #EEF0F3;
        }
      }
    }
    &-search {
      position: relative;
      width: 20%;
      display: flex;
      justify-content: flex-end;
      margin: 0 8px;

      > input {
        border: 1px solid #EEF0F3;
        box-sizing: border-box;
        border-radius: 4px;
        width: 100%;
        height: 40px;
        padding: 0 40px 0 15px;
        outline: none;
      }

      > img {
        position: absolute;
        right: 15px;
        bottom: 50%;
        transform: translateY(50%);
        width: 14px;
        height: 14px;
      }
    }
    &-add {
      background: #2CB181;
      font-weight: 500;
      font-size: 14px;
      color: #FFFFFF;
      height: 40px;
      border: none;
      outline: none;
      border-radius: 4px;
      width: 20%;
      margin: 0 0 0 8px;
    }
    &-action {
      display: flex;
      justify-content: space-between;
      align-items: center;
      button {
        height: 20px;
        border: none;
        background: none;
        cursor: pointer;
        outline: none;
        > img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
</style>
